import { render, staticRenderFns } from "./DocumentToolbar.vue?vue&type=template&id=2c3edcba&"
import script from "./DocumentToolbar.vue?vue&type=script&lang=ts&"
export * from "./DocumentToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports